export const GENDER_OPTIONS = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
];

export const PHOTO_MAX_SIZE_BYTES = 1_048_576; // 1MB
export const PHOTO_ACCEPTED_TYPES = ['image/jpeg', 'image/png'];
